import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "input-header-input",
  "data-cy": "input-header"
}
const _hoisted_2 = { class: "placeholder" }
const _hoisted_3 = { class: "input-header__button--border-bottom" }
const _hoisted_4 = { class: "input-header__editor" }
const _hoisted_5 = { class: "input-header__editor--container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_list_header = _resolveComponent("list-header")!
  const _component_form_input = _resolveComponent("form-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", {
      class: "input-header__button row",
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.toggleEdit()), ["stop"]))
    }, [
      _renderSlot(_ctx.$slots, "title", { loading: _ctx.loading }, () => [
        _createVNode(_component_q_icon, {
          class: "file-icon",
          size: "xs",
          style: {"color":"var(--directr__lightish-blue)","font-size":"15px","margin":"0 5px 0 0"},
          flat: "",
          round: "",
          dense: "",
          name: "svguse:icons/essential/42-pen.svg#Ebene_1"
        }),
        _withDirectives(_createElementVNode("span", _hoisted_2, "...", 512), [
          [_vShow, _ctx.loading]
        ]),
        _createElementVNode("div", _hoisted_3, [
          _withDirectives(_createVNode(_component_list_header, {
            title: String(_ctx.modelValue || _ctx.placeholder)
          }, null, 8, ["title"]), [
            [_vShow, !_ctx.loading]
          ])
        ])
      ], true)
    ], 512), [
      [_vShow, !_ctx.editing]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_4, [
      _renderSlot(_ctx.$slots, "editor", { save: _ctx.save }, () => [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_form_input, {
            autofocus: true,
            ref: "input",
            value: _ctx.modelValue,
            step: _ctx.step,
            placeholder: _ctx.type !== 'text' && isNaN(parseInt(_ctx.placeholder !== undefined ? String(_ctx.placeholder) : '')) ? undefined : String(_ctx.placeholder),
            onKeyup: [
              _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.save($event.target.value)), ["enter"])),
              _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.editing = false), ["esc"]))
            ],
            onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.save($event.target.value))),
            type: _ctx.type,
            min: _ctx.min,
            max: _ctx.max
          }, null, 8, ["value", "step", "placeholder", "type", "min", "max"])
        ])
      ], true)
    ], 512), [
      [_vShow, _ctx.editing]
    ])
  ]))
}